<template>
  <SidebarRoot :groups class="docs-page docs-titles">
    <template #logo>
      <SidebarLogo :to="user ? '/dashboard' : '/'" name="Otago" logo="/images/logo/otago.svg" />
    </template>
    <main class="max-w-4xl">
      <h1>Documentation</h1>

      <div>
        <NuxtLink to="#getting-started">
          <h2 id="getting-started"><DocsIconFire /> Getting started</h2>
        </NuxtLink>

        <div class="mt-3">
          <DashboardOnboarding />
        </div>
      </div>

      <DocsOverview />

      <DocsHowTo :project />

      <!-- <DocsGuides /> -->
    </main>
  </SidebarRoot>
</template>

<script setup lang="ts">
const route = useRoute();
const { project_ref } = route.params;

const user = useUser();
const projects = useCompanyProjects();
const project = computed(
  () => projects.value.find((p) => p.ref === project_ref) || projects.value[projects.value.length - 1],
);

const seo = {
  title: "Otago - Documentation",
  description:
    "Documentation of how to configure Otago as your custom server for expo-updates and react-native OTA updates and code pushes.",
};
useHead({
  title: seo.title,
  meta: [
    { name: "description", content: seo.description },
    { property: "og:title", content: seo.title },
    { property: "og:description", content: seo.description },
  ],
});

const groups = computed(() => [
  {
    title: "Getting started",
    link: "/docs#getting-started",
    icon: resolveComponent("DocsIconFire"),
  },
  {
    title: "Overview",
    link: "/docs#overview",
    icon: resolveComponent("DocsIconClipboard"),
    items: [{ title: "Architecture", link: "/docs#overview-architecture" }],
  },
  {
    title: "How to?",
    link: "/docs#how-to",
    icon: resolveComponent("DocsIconBookmark"),
    items: [
      { title: "Configure", link: "/docs#how-to-configure" },
      { title: "Handle envs", link: "/docs#how-to-handle-envs" },
      { title: "Sign deployments", link: "/docs#how-to-sign-deployments" },
      { title: "Deploy", link: "/docs#how-to-deploy" },
      // { title: "Deploy from CI", link: "/docs#how-to-deploy-from-ci" },
    ],
  },
  // {
  //   title: "Guides",
  //   link: "/docs#guides",
  //   icon: resolveComponent("DocsIconBook"),
  //   items: [
  //     { title: "Expo > v42", link: "/docs#guides-expo-v42" },
  //     { title: "React-native", link: "/docs#guides-react-native" },
  //   ],
  // },
]);
</script>

<style>
.docs-page {
  main {
    @apply p-4 md:p-7 lg:p-10;
  }
}
</style>
